import { motion } from "framer-motion";
import Marquee from "react-fast-marquee";

const EASE = [0.22, 1, 0.36, 1];

export function FadeIn({ children, delay = 0, y = 28, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({ lines, delay = 0, innerClassName = "" }) {
  return (
    <>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.14em] -mb-[0.14em]">
          <motion.span
            className={`block ${innerClassName}`}
            initial={{ y: "115%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1.05, delay: delay + i * 0.13, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </>
  );
}

export function EditorialMarquee({ items, testid = "editorial-marquee" }) {
  return (
    <div className="border-y border-olive/10 bg-sage-mist py-5" data-testid={testid}>
      <Marquee speed={22} gradient={false} pauseOnHover>
        {items.map((t, i) => (
          <span key={i} className="mx-10 inline-flex items-center gap-10">
            <span className="font-display italic text-2xl text-olive/80">{t}</span>
            <span className="h-1.5 w-1.5 rounded-full bg-teal/60" aria-hidden />
          </span>
        ))}
      </Marquee>
    </div>
  );
}

export function ChapterHeading({ number, title, className = "" }) {
  return (
    <FadeIn className={`flex items-baseline gap-4 ${className}`}>
      <span className="font-display italic text-teal text-xl" aria-hidden>
        ({number})
      </span>
      <h3 className="font-serif text-2xl lg:text-3xl tracking-tight text-ink">{title}</h3>
    </FadeIn>
  );
}
